import React from 'react'

import classes from './EmployeeCard.scss'

import Card from '../../../../../UI/Card/Card'
import EmployeeImage from './EmployeeImage/EmployeeImage'
import EmployeeInfo from './EmployeeInfo/EmployeeInfo'
import EmployeeActions from './EmployeeActions/EmployeeActions'

const employeeCard = ({ empData, selected, onEmpSelected, editDisabled }) => {
  return (
    <div className={classes.EmployeeCard}>
      <Card customClass={classes.Card}>
        <div className={classes.Body}>
          <EmployeeImage src={empData.image_path} empName={empData.full_name} />
          <EmployeeInfo info={empData} />
          <EmployeeActions
            recordId={empData.emp_id}
            onSelect={onEmpSelected}
            selected={selected}
            editDisabled={editDisabled}
          />
        </div>
      </Card>
    </div>
  )
}

export default employeeCard
